import Footer from '../components/Footer'
import Header from '../components/Header'
import Product from '../components/Product';
import boxer100 from "../images/boxer.jpg";
import boxer150 from "../images/boxer2.jpg";
import pulsar150 from "../images/pulsar-150.jpg";
import pulsar180 from "../images/pulsar-180.jpg";
import pulsar200 from "../images/pulsar-200.jpg";
import pulsar220 from "../images/pulsar-220.jpg";
import discover125 from "../images/discover-125.jpg";
import discover150 from "../images/discover-150.jpg"; 
import maxima from "../images/maxima.jpg";
import maximac from "../images/maxima-c.jpg";
import daily from "../images/daily.png";
import elec from "../images/elec.png";
import dream from "../images/dream.png";
import tooth from "../images/tooth.JPG";
import qute from "../images/qute.jpg";
import bajaj3 from "../images/bajaj3.jpg";
import maximaz from "../images/maxima-z-2.jpg";

const Products = () => {
  return (
    <div>
      <Header />
       <section id="products">
        <div class="container text-center">
            <h2 id="title">PRODUCTS</h2>
            <div class="row">
                <div class="col-lg-4 wow zoomIn">
                <Product img={elec} text="Horra Max 7" link="/products/max7"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={dream} text="Dream One" link="/products/dream"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={tooth} text="Excavator Tip" link="/products/tooth"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={boxer100} text="Boxer 100" link="/products/boxer100"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={boxer150} text="Boxer 150" link="/products/boxer150"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={pulsar150} text="Pulsar 150" link="/products/pulsar150"/>
                </div>
                
                <div class="col-lg-4 wow zoomIn">
                <Product img={pulsar180} text="Pulsar 180" link="/products/pulsar180"/>
                </div>
              
                <div class="col-lg-4 wow zoomIn">
                <Product img={pulsar200} text="Pulsar 200" link="/products/pulsar200"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                <Product img={pulsar220} text="Pulsar 220" link="/products/pulsar220"/>
                </div>
                
                <div class="col-lg-4 wow zoomIn">
                <Product img={discover125} text="Discover 125" link="/products/discover125"/>
                </div>
                
                <div class="col-lg-4 wow zoomIn">
                <Product img={discover150} text="Discover 150" link="/products/discover150"/>
                </div>
                
                <div class="col-lg-4 wow zoomIn">
                    <Product img={daily} text="Iveco Daily" link="/products/daily"/>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 wow zoomIn">
                    <Product img={maximaz} text="Maxima Z" link="/products/maxima-z"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                    <Product img={bajaj3} text="RE Compact" link="/products/re-compact"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                    <Product img={qute} text="Qute" link="/products/qute"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                    <Product img={maxima} text="Maxima" link="/products/maxima"/>
                </div>
                <div class="col-lg-4 wow zoomIn">
                    <Product img={maximac} text="Maxima-C" link="/products/maxima-c"/>
                </div>
            </div>
        </div>
    </section>
      <Footer />
    </div>
  )
}

export default Products